<template>
  <b-container fluid id="app">
    <b-row>
      <b-col class="align-items-center mr-2 ml-2 pl-3 pr-3" style="text-align: center;">
        Você precisa fazer login na plataforma
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {

}
</script>

<style>

</style>
